// Centralized constants for legal docs. Update in one place when entity / lawyer changes them.
export const LEGAL = {
  companyName: "Micro/Trade",
  companyAlias: "we, us, our, the Service, the Platform",
  legalEmail: "legal@microtrade.io",
  supportEmail: "support@microtrade.io",
  jurisdiction: "United States",
  governingState: "Delaware",
  effectiveDate: "May 18, 2026",
  domain: "microtrade.io",
};

export const PRE_LAWYER_BANNER = (
  "This document is a starting-point template generated by software. " +
  "It has NOT been reviewed by a licensed attorney. Before relying on it " +
  "for production use, you MUST have a qualified securities / fintech " +
  "lawyer in your jurisdiction review and modify it."
);
